// PR-1b — printing a label is one step: the print box, not a viewer tab.
// The bytes are fetched through the session the way openPdf does it (a new tab
// carries no Authorization header), then handed to a hidden iframe whose own
// window is told to print. The page the server drew is the size of the stock,
// so the browser's box opens on a label, not on Letter.
import axios from 'axios';
import { toast } from 'sonner';
import { openPdf } from './openPdf';

export async function printPdf(apiPath, { params } = {}) {
  let url = '';
  let printing = false;
  const full = params
    ? `${apiPath}${apiPath.includes('?') ? '&' : '?'}${new URLSearchParams(params)}`
    : apiPath;
  const viewer = () => {
    toast.error('Opened the PDF instead — print from there');
    return openPdf(full);
  };
  try {
    const res = await axios.get(apiPath, { responseType: 'blob', params });
    url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.dataset.kmPrint = 'label';
    frame.style.position = 'fixed';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.style.visibility = 'hidden';
    const done = () => {
      frame.remove();
      URL.revokeObjectURL(url);
    };
    frame.onload = () => {
      try {
        const win = frame.contentWindow;
        printing = true;
        win.focus();
        // Once the box closes the frame goes; the timer is the belt for the
        // browsers that never fire afterprint.
        win.addEventListener?.('afterprint', done);
        win.print();
        setTimeout(done, 60000);
      } catch {
        done();
        viewer();
      }
    };
    frame.src = url;
    document.body.appendChild(frame);
    // Some browsers have no PDF viewer to load the frame into at all; when
    // nothing has loaded, the viewer is the honest answer.
    setTimeout(() => {
      if (!printing) {
        frame.remove();
        URL.revokeObjectURL(url);
        viewer();
      }
    }, 4000);
    return true;
  } catch (e) {
    if (url) URL.revokeObjectURL(url);
    await viewer();
    return false;
  }
}

export default printPdf;
